import script from "./FolderListBase.vue?vue&type=script&lang=ts&setup=true"
export * from "./FolderListBase.vue?vue&type=script&lang=ts&setup=true"

import "./FolderListBase.vue?vue&type=style&index=0&id=75966732&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75966732"]])

export default __exports__